import { useForm } from 'react-hook-form'
import { useEffect, useRef } from 'react'
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom'
import { usePrice } from '../../components/Context/Context'
import { nextPage } from 'components/RCPro/helpers/nav'
import PhoneNumber from 'components/RCPro/components/form/PhoneNumber/PhoneNumber'
import Email from 'components/RCPro/components/form/Email/Email'
import Link from 'components/common/Link/Link'
import Arrow from 'components/assets/icons/Arrow'
import Button from 'components/common/Button/Button'
import { formParams } from 'constants/inputValidation'
import style from './Contacts.module.scss'

const RCProContacts = () => {
  const navigate = useNavigate()
  const { state, pathname } = useLocation()
  const { nextPageTransition } = useOutletContext()
  const { contacts } = state.texts
  const { codeProduct, turnover, activity, token } = state
  const { price: { price, LOI, tarificateur }, getPrice } = usePrice()
  const hasFetched = useRef(false)

  // Initialize form
  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
    control
  } = useForm({
    ...formParams,
    values: {
      email: state.email || '',
      phone: state.phone?.number || ''
    },
  })

  // Checking tarificateur
  useEffect(() => {
    if (!hasFetched.current){
      hasFetched.current = true
      getPrice({ codeProduct, turnover, activity, token, check: true })
    }
  }, [getPrice, codeProduct, turnover, activity, token])

  const onSubmit = handleSubmit(async data => {
    if (price && LOI) {
      data.price = price
      data.LOI = LOI
      data.tarificateur = tarificateur
    }
    data.email = data.email.trim()
    nextPage({ pathname, state, navigate, data })
    nextPageTransition()
  })

  return (
    <>
      <h1>{contacts?.title} 💌</h1>

      <form onSubmit={onSubmit}>
        <Email
          register={register}
          error={errors.email}
        />

        <PhoneNumber
          control={control}
          error={errors.phone}
          value={state?.phone?.number || ''}
        />

        <p className={style.legalterms}>
          {contacts?.legalterms}
          &nbsp;
          <Link
            target={'_blank'}
            label={contacts?.link}
            to={'https://www.get-owen.com/fr/politique-de-confidentialite'}
          />
        </p>

        <Button
          label={<>{contacts?.button} <Arrow /></>}
          onClick={handleSubmit}
          className={style.button}
          disabled={!isValid}
          type="primary"
        />
      </form>
    </>
  )
}

export default RCProContacts